export const qualityOverrides: Record<string, Record<string, string>> = {
  es: {
    "Add them to cart.": "Agrégalos al carrito.",
    "Add to Bag": "Añadir al carrito",
    "Added to bag": "Añadido al carrito",
    "Adding...": "Añadiendo...",
    "ANALYZING BODY": "ANALIZANDO CUERPO",
    "best match": "mejor ajuste",
    "BEST MATCH": "MEJOR AJUSTE",
    "CALIBRATING SCALE": "CALIBRANDO ESCALA",
    "Generating Your Look": "Generando tu look",
  },
  fr: {
    "Add them to cart.": "Ajoutez-les au panier.",
    "Add to Bag": "Ajouter au panier",
    "Added to bag": "Ajouté au panier",
    "Adding...": "Ajout...",
    "ANALYZING BODY": "ANALYSE DU CORPS",
    "best match": "meilleur ajustement",
    "BEST MATCH": "MEILLEUR AJUSTEMENT",
    "CALIBRATING SCALE": "CALIBRAGE DE L'ÉCHELLE",
    "Generating Your Look": "Génération de votre look",
  },
  de: {
    "Add them to cart.": "In den Warenkorb legen.",
    "Add to Bag": "In den Warenkorb",
    "Added to bag": "Im Warenkorb",
    "Adding...": "Wird hinzugefügt...",
    "ANALYZING BODY": "KÖRPER WIRD ANALYSIERT",
    "best match": "beste Passform",
    "BEST MATCH": "BESTE PASSFORM",
    "CALIBRATING SCALE": "SKALIERUNG WIRD KALIBRIERT",
    "Generating Your Look": "Dein Look wird erstellt",
  },
  it: {
    "Add them to cart.": "Aggiungili al carrello.",
    "Add to Bag": "Aggiungi al carrello",
    "Added to bag": "Aggiunto al carrello",
    "Adding...": "Aggiunta...",
    "ANALYZING BODY": "ANALISI DEL CORPO",
    "best match": "migliore vestibilità",
    "BEST MATCH": "MIGLIORE VESTIBILITÀ",
    "CALIBRATING SCALE": "CALIBRAZIONE DELLA SCALA",
    "Generating Your Look": "Generazione del tuo look",
  },
  pt: {
    "Add them to cart.": "Adicione ao carrinho.",
    "Add to Bag": "Adicionar ao carrinho",
    "Added to bag": "Adicionado ao carrinho",
    "Adding...": "Adicionando...",
    "ANALYZING BODY": "ANALISANDO O CORPO",
    "best match": "melhor ajuste",
    "BEST MATCH": "MELHOR AJUSTE",
    "CALIBRATING SCALE": "CALIBRANDO ESCALA",
    "Generating Your Look": "Gerando seu look",
  },
  ja: {
    "Add them to cart.": "カートに追加",
    "Add to Bag": "カートに追加",
    "Added to bag": "カートに追加済み",
    "Adding...": "追加中...",
    "ANALYZING BODY": "身体を分析中",
    "best match": "最適なフィット",
    "BEST MATCH": "最適なフィット",
    "CALIBRATING SCALE": "スケールを調整中",
    "Generating Your Look": "ルックを生成中",
  },
  zh: {
    "Add them to cart.": "加入购物车。",
    "Add to Bag": "加入购物车",
    "Added to bag": "已加入购物车",
    "Adding...": "正在添加...",
    "ANALYZING BODY": "正在分析身体",
    "best match": "最佳合身",
    "BEST MATCH": "最佳合身",
    "CALIBRATING SCALE": "正在校准比例",
    "Generating Your Look": "正在生成你的造型",
  },
  ko: {
    "Add them to cart.": "장바구니에 추가",
    "Add to Bag": "장바구니에 추가",
    "Added to bag": "장바구니에 추가됨",
    "Adding...": "추가 중...",
    "ANALYZING BODY": "신체 분석 중",
    "best match": "가장 잘 맞음",
    "BEST MATCH": "가장 잘 맞음",
    "CALIBRATING SCALE": "스케일 보정 중",
    "Generating Your Look": "룩 생성 중",
  },
  ar: {
    "Add them to cart.": "أضفها إلى السلة.",
    "Add to Bag": "أضف إلى السلة",
    "Added to bag": "تمت الإضافة إلى السلة",
    "Adding...": "جارٍ الإضافة...",
    "ANALYZING BODY": "جارٍ تحليل الجسم",
    "best match": "أفضل ملاءمة",
    "BEST MATCH": "أفضل ملاءمة",
    "CALIBRATING SCALE": "جارٍ معايرة المقياس",
    "Generating Your Look": "جارٍ إنشاء مظهرك",
  },
};
